import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropType from 'prop-types';
import {
  MEASUREMENT_FORMAT_STORAGE_KEY,
  MEASUREMENT_FORMAT
} from 'state/global/profile/util/constant';
import { selectGlobalMyProfile } from 'state/global/profile/selector';
import { squareMeterToFeet } from 'util/measurement-format';

export const CleanedSquareValue = ({ cleanedSquareMeter }) => {
  const { t } = useTranslation();
  const globalMyProfile = useSelector((state) => selectGlobalMyProfile(state));

  const measurementFormat = useMemo(() => {
    return globalMyProfile[MEASUREMENT_FORMAT_STORAGE_KEY];
  }, [globalMyProfile]);

  return (
    <span>
      {t(
        measurementFormat === MEASUREMENT_FORMAT.METRIC
          ? 'unit.squareMeter'
          : 'unit.squareFeet',
        {
          value: Math.round(
            measurementFormat === MEASUREMENT_FORMAT.METRIC
              ? cleanedSquareMeter
              : squareMeterToFeet(cleanedSquareMeter)
          )
        }
      )}
    </span>
  );
};

CleanedSquareValue.propTypes = {
  cleanedSquareMeter: PropType.number.isRequired
};

export default CleanedSquareValue;
